import React, { useContext } from "react";
import { Box, Typography, ImageList, ImageListItem } from "@mui/material";
import { LangContext } from "../../LanguageProvider";

const images = [
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694855991_1.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694855996_2.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856000_3.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856005_4.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856008_5.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856012_6.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856015_7.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856016_8.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856055_9.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856060_10.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856064_11.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856067_12.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856070_13.jpg",
  "https://admin.bkogov.kz/sites_files/rvtk.bkogov.kz/abiturientam/1/1694856072_14.jpg",
];

const StudentAdmissionRules = () => {
  const { translations } = useContext(LangContext);

  return (
    <Box
      sx={{
        fontSize: "16px",
        padding: 0,
        maxWidth: "100%",
        marginTop: "100px",
        marginBottom: "100px",
      }}>
      {/* Page Header */}
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "center" }}>
        <Typography variant="h4" component="h1" sx={{ fontSize: "26px" }}>
          {translations["prav priem"]}{" "}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          16.09.2023
        </Typography>
      </Box>

      {/* Page Content */}

      {/* Image Gallery */}
      <ImageList cols={1} gap={10} sx={{ maxWidth: "600px", margin: "0 auto" }}>
        {images.map((src, index) => (
          <ImageListItem
            key={index}
            sx={{ border: "2px solid black", borderRadius: "8px" }}>
            <img
              src={src}
              alt={`Student Admission ${index + 1}`}
              loading="lazy"
              style={{
                backgroundColor: "#f1f1f1",
                width: "100%",
                height: "auto",

                objectFit: "cover",
                borderRadius: "20px",
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
};

export default StudentAdmissionRules;
